import MessengerChatEndPopover from '@widgets/messenger/components/popovers/MessengerChatEndPopover.vue'
import MessengerSatisfactionSurveyRatePopover from '@widgets/messenger/components/popovers/MessengerSatisfactionSurveyRatePopover.vue'
import MessengerSatisfactionSurveyCommentPopover from '@widgets/messenger/components/popovers/MessengerSatisfactionSurveyCommentPopover.vue'
import type { MessengerChatRate } from '@widgets/messenger/types/chat/chat'
import type { AnyComponent } from '@/components/types'

export type Popovers = {
  endChat: {
    email: string
    onEndChat: () => Promise<void>
    onCancel: () => void
  }
  satisfactionSurveyRate: {
    onRate: (rate: MessengerChatRate) => Promise<void>
    onSkip: () => void
  }
  satisfactionSurveyComment: {
    rate: MessengerChatRate
    onSendComment: (comment: string) => Promise<void>
    onSkip: () => void
  }
}

export type PopoverName = keyof Popovers

export const popoverComponentMap: Record<PopoverName, AnyComponent> = {
  endChat: MessengerChatEndPopover,
  satisfactionSurveyRate: MessengerSatisfactionSurveyRatePopover,
  satisfactionSurveyComment: MessengerSatisfactionSurveyCommentPopover,
} as const

export type OpenedPopover<T extends PopoverName> = { name: T; payloadGetter: () => Popovers[T] }
